import { render, staticRenderFns } from "./HeaderResale.vue?vue&type=template&id=a364c10c&scoped=true"
import script from "./HeaderResale.vue?vue&type=script&lang=js"
export * from "./HeaderResale.vue?vue&type=script&lang=js"
import style0 from "./HeaderResale.vue?vue&type=style&index=0&id=a364c10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a364c10c",
  null
  
)

export default component.exports